import {replaceObj} from '@/utils/utils'
export default {
	data() {
		return {
			mode: 'page', //模式 page|dialog
			option:{},
			queryParams: {},
			api: {},
			stats: {},
			table: {
				datas: []
			},
			pagination: {
				count: 0,
				size: 20,
				current: 1
			},
			dialog: {// FORM DIALOG
				visible: false,
				params: {
					id: ''
				}
			},
			detailDialog: {// DETAIL DIALOG
				visible: false,
				params: {
					id: ''
				}
			}
		}
	},
	mounted() {
		if (this.mode == 'dialog') {
			return false
		}
		this.index()
		this.load()
	},
	props: {
		params: {
			type: Object,
			default: () => {
				return {}
			}
		},
		visible: {
	    type: Boolean,
	    default: false
		}
	},
	filters: {
		stateFilter(state) {
			return state == 1 ? 'success' : 'danger'
		}
	},
	methods: {
		index() {
			// 没定义index直接退出
			if (this.api.index === undefined) {
				return false
			}
			// 执行
			this.api.index().then(res=> {
				res.data.option !== undefined && replaceObj(this.option, res.data.option)
			})
		},
		init() {
		},
		load() {
			// 没定义list直接退出
			if (this.api.search === undefined) {
				return false
			}
			// 执行
			this.api.search(Object.assign(this.queryParams, {
				page: this.pagination.current,
				size: this.pagination.size			
			})).then(res=> {
				this.table.datas = res.data.datas === undefined ? [] : res.data.datas
				this.pagination.count = res.data.count === undefined ? 0 : res.data.count
				this.stats = res.data.stats === undefined ? {} : res.data.stats 
			})
		},
		setSearchField(field, value) {
			if (Array.isArray(field) === true) {
				this.queryParams[field[0]] = value === null ? '' : value[0]
				this.queryParams[field[1]] = value === null ? '' : value[1]
			} else {
				this.queryParams[field] = value
			}
		},
		search() {
			this.pagination.current = 1
			this.load()
		},
		sort(column) {
			let orderBy = column.prop.substr(0, 1) == '_' ? column.prop.substr(1) : column.prop
			this.queryParams.orderBy = column.order === null ? '' : orderBy
			this.queryParams.sort = column.order == 'ascending' ? 'asc' : 'desc'
			this.load()
		},
		currentChange(val) {
			this.pagination.current = val
			this.load()
		},
		create() {
			this.dialog.params.id = ''
			this.dialog.visible = true
		},
		edit(id) {
			this.dialog.params.id = id
			this.dialog.visible = true
		},
		remove(id, name, idx = '') {
			// 没方法
			if (this.api.delete === undefined) {
				return false
			}

			// 开始删除
			this.$confirm(`确认删除“${name}”？`, '提示', {
				type: 'warning'
			}).then(()=> {
				this.api.delete(id).then(res=> {
					if (res.code == 1) {
						idx === '' ? this.load() : this.table.datas.splice(idx, 1)
					}
				})
			}).catch(()=>{
			})
		},
		read(id) {
			this.detailDialog.params.id = id
			this.detailDialog.visible = true
		},
		open() {
			this.index()
			this.init()
			this.load()
		},
		close() {
			this.$emit('update:visible', false)
		}
	}
}